import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import getAccount from "Redux/Actions/GetAccountAction";
import MODALMESSAGES from "Constants/Messages";
import AppConstants from "Constants/AppConstants";

import { getProductFromVault } from "Components/MarketPlace/Action/MarketPlaceAction";
import {
  getLendingProduct,
  updateLendingProduct,
} from "Components/LoanDetails/Actions/LoanDetailsAction";
import withApplicantHOC from "Hoc/ApplicantHOC/ApplicantHOC";
import Disbursement from "./Disbursement";
import { getApplicationProperty } from "../JointApplicant/Actions/JointApplicantAction";
import Signature from "../Signature/Signature";
import InveriteAccountList from "../Inverite/InveriteAccountList";
import { callCreateInveriteAccountList } from "Components/Inverite/Actions/InveriteAction";
import { HTTP_STATUS } from "Communication/Constants";
import { getApplicantBankingProductList } from "../AccountInformation/Actions/AccountInformationAction";
import { updateProductToVault } from "../MarketPlace/Action/MarketPlaceAction";
import STRINGS from "../../Constants/Strings";

class DisbursementContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalType: "",
      modal: {
        title: "",
        description: "",
      },
      choice: "",
      disbursement: {},
      accountList: [],
      productList: [],
      accountError: [],
    };
  }

  componentDidMount() {
    const {
      products,
      getActiveProduct,
      bankingProductList,
      doGetApplicantBankingProductList,
    } = this.props;

    const activeProduct = getActiveProduct(products);
    if (activeProduct) {
      if (activeProduct.accountList) {
        this.setState({
          accountList: activeProduct.accountList,
        });
      }
      if (activeProduct.disbursement) {
        this.setState({
          disbursement: activeProduct.disbursement,
        });
      }
      if (bankingProductList) {
        const productList = bankingProductList.products?.filter(
          (product) => product.productCode === AppConstants.PRODUCT_CODE.PC
        );
        console.log("productList", productList);
        this.setState({
          productList,
        });
      } else {
        doGetApplicantBankingProductList(
          activeProduct.applicantId,
          (response) => {
            const productList = response.products?.filter(
              (product) => product.productCode === AppConstants.PRODUCT_CODE.PC
            );
            this.setState({
              productList,
            });
          }
        );
      }
    }
    console.log(activeProduct);
  }

  updateDisbursement = (disbursement) => {
    console.log("updateDisbursement", disbursement);
    if (disbursement) {
      this.setState({
        disbursement,
      });
    }
  };

  handleChange = () => {};

  handleContinue = () => {
    const { disbursement } = this.state;
    console.log("handleContinue", disbursement);
    const {
      continuehandler,
      products,
      getActiveProduct,
      doGetApplicationProperty,
      applicantData,
      doUpdateProductToVault,
      doUpdateLendingProduct,
    } = this.props;

    const activeProduct = getActiveProduct(products);

    let disbursementData = {};

    if (disbursement.accountType) {
      if (disbursement.accountType === AppConstants.ACCOUNT_TYPE.OTHER) {
        disbursementData = {
          DisbDep1AcctNo: disbursement.selectedOtherAccount,
          DisbDep1Type: disbursement.accountType,
          DisbComment: disbursement.comment,
        };
      } else {
        disbursementData = {
          DisbDep1AcctNo: disbursement.basicDetails.acctNo,
          DisbDep1Type: disbursement.accountType,
          DisbComment: disbursement.comment,
        };
      }

      doUpdateLendingProduct(
        activeProduct.applicationId,
        activeProduct.doximProductId,
        disbursementData,
        (res) => {
          console.log(res);
          products[0].disbursement = disbursement;
          doUpdateProductToVault(products, () => {
            continuehandler(null, AppConstants.APPLICATIONSTEP.DISBURSEMENT);
          });
        }
      );
    } else {
      this.setState({
        accountError: [STRINGS.DISBURSEMENT.ERROR.REQUIRED],
      });
    }
  };

  composeDisbursementData() {
    let data = {};
    const { disbursement } = this.state;
    if (disbursement.accountType === AppConstants.ACCOUNT_TYPE.OTHER) {
    } else {
      data = {
        LPBasicDetails: {
          AdvanceTypeCode: "1",
          SecTypeCode: "2",
        },
        LPTermsDetails: {
          PrePayTypeCode: "1",
        },
        LPDisbursementDetails: {
          DisbDep1AcctNo: disbursement.basicDetails.acctNo,
          DisbDep1Type: "hisa",
          DisbDep1Sub: 12,
          DisbDep1Amt: 100.11,
          DisbLoan1AcctNo: "976754536",
          DisbLoan1Sub: 12,
          DisbLoan1Amt: 100.11,
          DisbPayee1: "ABC",
          disbPayee1Amt: 100.11,
        },
      };
    }

    return data;
  }

  updateLendingProductDisbursement(
    applicationId,
    doximProductId,
    disbursement
  ) {
    const { doUpdateLendingProduct } = this.props;
    if (disbursement) {
      doUpdateLendingProduct(
        applicationId,
        doximProductId,
        {
          DisbDep1AcctNo: disbursement.accountNo,
          DisbDep1Type: disbursement.accountType,
          DisbDep1Sub: 12,
          DisbDep1Amt: 100.11,
          DisbLoan1AcctNo: disbursement.accountNo,
          DisbLoan1Sub: 12,
          DisbLoan1Amt: 100.11,
          DisbPayee1: "ABC",
          disbPayee1Amt: 100.11,
          DisbComment: disbursement.comments,
        },
        (res) => {
          console.log(res);
        }
      );
    }
    console.log(disbursement);
  }

  toggleModal = () => {};

  showModal = () => {
    this.setState({});
  };

  handlePopupModalBtnClick = () => {
    const { signatureCompleted } = this.state;
    const { continuehandler } = this.props;
    if (signatureCompleted) {
      continuehandler({}, AppConstants.APPLICATIONSTEP.DISBURSEMENT);
    }
  };

  openInverite = () => {
    console.log("openInverite");
    const { doCreateInveriteAccountList } = this.props;
    doCreateInveriteAccountList((response) => {
      console.log(response);
      if (response.status === HTTP_STATUS.OK) {
        sessionStorage.setItem(
          AppConstants.SESSION.INVERITE_ACCOUNTLIST_REQUEST_GUID,
          response.data.requestGuid
        );
        this.setState({
          iframeModal: true,
          iframeUrl: response.data.iframeUrl,
        });
      }
    });
  };

  processInverite = (data) => {
    const { doUpdateProductToVault, products } = this.props;
    const { disbursement } = this.state;
    console.log("processInverite", data);
    const updateAccountList = data.accountList.map((acct) => {
      return {
        account: acct.account,
        account_description: acct.account_description,
        bank: acct.bank,
        institution: acct.institution,
        membership_number: acct.membership_number,
        routing_code: acct.routing_code,
        transit: acct.transit,
        type: acct.type,
      };
    });
    products[0].accountList = updateAccountList;
    doUpdateProductToVault(products, () => {
      this.setState({
        iframeModal: false,
        accountList: updateAccountList,
        disbursement: {
          ...disbursement,
          accountType: AppConstants.ACCOUNT_TYPE.OTHER,
        },
      });
    });
  };

  closeInveriteWindow = () => {
    this.setState({
      iframeModal: false,
    });
  };

  render() {
    const {
      choice,
      modal,
      modalType,
      showModal,
      iframeModal,
      iframeUrl,
      accountList,
      disbursement,
      productList,
      accountError,
    } = this.state;
    const {
      getDataFromServer,
      handleBack,
      steps,
      activeStepID,
      products,
      getActiveProduct,
    } = this.props;

    return (
      <>
        <Disbursement
          type={modalType}
          modal={modal}
          showModal={showModal}
          toggleModal={this.toggleModal}
          handlePopupModalBtnClick={this.handlePopupModalBtnClick}
          handleContinue={this.handleContinue}
          handleChange={this.handleChange}
          getDataFromServer={getDataFromServer}
          choice={choice}
          handleBack={handleBack}
          steps={steps}
          activeStepID={activeStepID}
          openInverite={this.openInverite}
          accountList={accountList}
          disbursement={disbursement}
          updateDisbursement={this.updateDisbursement}
          productList={productList}
          accountError={accountError}
        />
        {iframeModal && (
          <InveriteAccountList
            iframeUrl={iframeUrl}
            iframeModal={iframeModal}
            toggleModal={this.toggleModal}
            showModal={iframeModal}
            popupBtnClick={this.toggleModal}
            processInverite={this.processInverite}
            closeBtnClick={this.closeInveriteWindow}
          />
        )}
      </>
    );
  }
}

DisbursementContainer.propTypes = {
  getDataFromServer: PropTypes.func.isRequired,
  continuehandler: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
};

DisbursementContainer.defaultProps = {
  steps: [],
  activeStepID: -1,
};

const mapStateToProps = (state) => ({
  MemberExists: state.MemberExistsReducer,
  products: state.VaultReducer.vaultProductList,
  applicantData: state.ApplicationReducer.response,
  bankingProductList: state.AccountInformationReducer.bankingProductList,
});

const mapDispatchToProps = (dispatch) => {
  return {
    doGetAcoountDetails: (callback) => dispatch(getAccount(callback)),
    doGetProductFromVault: (callback) =>
      dispatch(getProductFromVault(callback)),
    doGetLendingProduct: (applicationId, doximProductId, callback) =>
      dispatch(getLendingProduct(applicationId, doximProductId, callback)),
    doUpdateLendingProduct: (
      applicationId,
      doximProductId,
      payLoad,
      callback
    ) =>
      dispatch(
        updateLendingProduct(applicationId, doximProductId, payLoad, callback)
      ),
    doGetApplicationProperty: (request, callback) =>
      dispatch(getApplicationProperty(request, callback)),
    doCreateInveriteAccountList: (callback) =>
      dispatch(callCreateInveriteAccountList(callback)),
    doGetApplicantBankingProductList: (applicantId, callback) =>
      dispatch(getApplicantBankingProductList(applicantId, callback)),
    doUpdateProductToVault: (vaultProductList, callback) =>
      dispatch(updateProductToVault(vaultProductList, callback)),
  };
};

const DisbursementWrapper = withApplicantHOC(DisbursementContainer);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DisbursementWrapper);
